<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p3-4/3-4-1.png" />
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p3-4/3-4-2.png" />
    <img class="ctn-image animate-target" v-animate-in src="../../assets/images/p3-4/3-4-3.png" />
    <GoNext class="animate-target" v-animate-in href="/section3/3-5">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from 'vuex';
export default {
  name: "s3-4",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{

  },
  data(){
    return{
      noticeTxt:"Figures adapted from KDIGO. Kidney Int 2020<br/><div class='brs'></div>"
      +"*UACR and eGFR cut offs:<sup>2,3</sup><div class='brs'></div>"
      +"<ul style='padding-left: 20px;'><li>FIDELIO DKD: UACR 30–<300 mg/g and eGFR ≥25–<60 ml/min/1.73 m<sup>2</sup> or UACR ≥300–≤5000 mg/g and eGFR ≥25–<75 ml/min/1.73 m<sup>2</sup></li>"
      +"<li>FIGARO DKD: UACR 30–300 mg/g and eGFR ≥25–≤90 ml/min/1.73 m<sup>2</sup> or UACR ≥300–≤5000 mg/g and eGFR ≥60 ml/min/1.73 m<sup>2</sup></li></ul><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. Ruilope LM, <i>et al. Am J Nephrol</i> 2019;50:345–356;<br/>"
      +"2. Bakris GL, <i>et al. Am J Nephrol</i> 2019;50:333–344;<br/>"
      +"3. Agarwal R, <i>et al. Eur Heart J</i> 2021; doi: 10.1093/eurheartj/ehab777/6433104;<br/>"
      +"4. KDIGO. <i>Kidney Int</i> 2020;98:S1–S115.",
      title:"FIDELIO-DKD and FIGARO-DKD assessed prespecified kidney outcomes in patients across the spectrum of CKD severity"
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section3/s3.css";
.ctn-image {
  width: 100%;
  margin-top: 40px;
}
</style>
